// jQuery must be initialized in a separate file, otherwise the import of
// bootstrap-sass will be hoisted up before jQuery initialization and Bootstrap
// won't be able to find jQuery.
import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;
